import http from "./http";
import { v4 as uuidV4 } from "uuid";

// export interface ChatMessageId {
//   mostSigBits: number;
//   leastSigBits: number;
// }
export type ChatMessageId = string;

export type FeedBackType = "GOOD" | "BAD" | "NONE";

export enum MessageSource {
  MANUAL = "MANUAL",
  QUESTION_LIB = "QUESTION_LIB",
  ASSOCIATION = "ASSOCIATION",
}

export enum MessageType {
  QUESTION = "QUESTION",
  ANSWER = "ANSWER",
}

export enum MessageStatus {
  COMPLETE = "COMPLETE",
  PROCESSING = "PROCESSING",
  STOP = "STOP",
  REVOKE = "REVOKE",
  ERROR = "ERROR",
}

export interface StartChatParams {
  streamName: string;
  message: string;
  messageSource: MessageSource;
}

export interface FeedBackParams {
  messageId: ChatMessageId;
  feedbackType: FeedBackType;
}

export interface Question {
  id: ChatMessageId;
  content: string;
}

export interface ChatMessage {
  id: ChatMessageId;
  streamName?: string;
  message: string;
  messageType?: MessageType;
  messageStatus?: MessageStatus;
  feedbackType?: FeedBackType;
  associationWord?: string[];
  questionId?: ChatMessageId;
  errorMsg?: string;
  createdDate?: string;
  updatedDate?: string;
}

export interface ChatMessageEventSource {
  messageId: ChatMessageId;
  event: "CONNECT" | "REPLY" | "DONE";
  content: string;
  DONE: boolean;
  timestamp: string;
}

export interface ConnectData {
  answerId: ChatMessageId;
  questionId: ChatMessageId;
}

export const generateEmptyMessage = (message?: Partial<ChatMessage>) => {
  const emptyMessage: ChatMessage = {
    id: message?.id || uuidV4(),
    message: "",
    messageType: MessageType.ANSWER,
    messageStatus: MessageStatus.PROCESSING,
    createdDate: new Date().toISOString(),
    ...message,
  };
  return emptyMessage;
};

export const START_CHAT_URL = `${import.meta.env.VITE_BACKEND_URL}/api/auth/chat/stream`;
export const CONTINUE_CHAT_URL = `${import.meta.env.VITE_BACKEND_URL}/api/auth/chat/stream-continue`;
export const REGENERATE_CHAT_URL = `${import.meta.env.VITE_BACKEND_URL}/api/auth/chat/stream-regenerate`;

export const getChatMessageList = (streamName: string) => {
  return http.get<ChatMessage[]>(`/api/auth/chat-message/list?streamName=${streamName}`);
};

export const getChatStatus = (streamName: string) => {
  return http.get(`/api/auth/chat-message/chat-status?streamName=${streamName}`);
};

export const stopGenerateChat = (streamName: string, messageId: ChatMessageId) => {
  return http.post("/api/auth/chat-message/actions/stop", { streamName, messageId });
};

export const feedBackChat = (params: FeedBackParams) => {
  return http.put("/api/auth/chat-message/actions/feedback", params);
};

export const generateAssociationWord = (params: { messageId: ChatMessageId }) => {
  return http.post<string[]>(`/api/auth/chat-message/actions/generate-association-word`, params);
};

export const getRandomQuestion = (params: { streamName: string; isInit: boolean }) => {
  const { streamName, isInit } = params;
  return http.get<Question[]>(`/api/auth/chat-question-lib/random-list?streamName=${streamName}&isInit=${isInit}`);
};
